import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function CustomDialog({ Content, title, isOpen, reset }) {
  const handleClose = (event, reason) => {
    // don't close on esc or backgroundClick
    if (reason) return;
    reset();
  };

  return (
    <Dialog fullWidth={true} maxWidth="sm" open={isOpen} onClose={handleClose}>
      <DialogTitle
        style={{
          fontFamily: "Segoe UI",
          fontWeight: 700,
          letterSpacing: 0,
          color: "#1D5AB9",
        }}
      >
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent style={{ padding: 0 }}>
        <Content enableNav={false} isDialog={true} resetDialog={reset} />
      </DialogContent>
    </Dialog>
  );
}
